import { PropsWithChildren } from "react";

export const ResponsiveTableHead = (props: PropsWithChildren<any>) => (
  <thead>{props.children}</thead>
);
